<span class="inputlabel" *ngIf="label !== ''"
  >{{ label }}<span *ngIf="required" class="color-weak"> *</span></span
>
<div
  *ngIf="FormControl.invalid && (FormControl.dirty || FormControl.touched)"
  class="input-error"
>
  <rr-icon name="octagon"></rr-icon>
  @if(FormControl.hasError('required')){
  <span i18n>This field is required</span>
  }@else if(FormControl.hasError('email')){
  <span i18n>Please enter a valid email address</span>
  }@else if(FormControl.hasError('pattern')){
  <span i18n>Your input is not valid</span>
  }@else if(FormControl.hasError('minLength')){
  <span i18n>Your password is too short.</span>
  }@else if(FormControl.hasError('uppercase')){
  <span i18n>Your password must contain at least one uppercase letter.</span>
  }@else if(FormControl.hasError('lowercase')){
  <span i18n>Your password must contain at least one lowercase letter.</span>
  }@else if(FormControl.hasError('number')){
  <span i18n>Your password must contain at least one number.</span>
  }@else if(FormControl.hasError('specialCharacter')){
  <span i18n>Your password must contain at least one special character.</span>
  }
</div>
<div
  class="inputwrapper row pw_{{ verifyPassword }}"
  [ngClass]="
    FormControl.invalid && (FormControl.dirty || FormControl.touched)
      ? errorClass
      : ''
  "
>
  <input
    [placeholder]="placeholder"
    [attr.disabled]="disabled ? true : null"
    (input)="onInput($event)"
    [formControl]="FormControl"
    [type]="type"
    [autocomplete]="autocomplete"
    [attr.min]="min || null"
    (keyup)="keyUp($event)"
  />
  <rr-icon
    *ngIf="verifyPassword"
    [name]="type == 'password' ? 'eye' : 'eye-off'"
    (click)="togglePassword()"
  ></rr-icon>
</div>
<small class="" *ngIf="hint !== ''">{{ hint }}</small>
